/*! @azure/msal-browser v2.16.0 2021-07-22 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.16.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
